import { render, staticRenderFns } from "./hygl.vue?vue&type=template&id=0ab06137&scoped=true"
import script from "./hygl.vue?vue&type=script&lang=js"
export * from "./hygl.vue?vue&type=script&lang=js"
import style0 from "../../views/member-page/assets/css/rem.css?vue&type=style&index=0&id=0ab06137&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab06137",
  null
  
)

export default component.exports